/* eslint eqeqeq: "off" */
import * as React from 'react';
import { connect } from 'react-redux';
import { postToController } from '../../actions/apiActions';
import { navigateTo } from '../../actions/navigationActions';
import { submitClaim, setLocation, setTimeShow, setCover, setIncidentEvent, setStep, setRiskItemAndIncident, setIsCar, getClaimDamagePhotoTypes, setSelectedDamagePhotoTypes, setDamagePosition, setSelectedAllTrue, setSelectedAllFalse, setIsInEdit, setFnolIncidentEventList, handleNextStep, handleStepBack } from '../../actions/claimSubmitActions';
import { SUBMIT_CLAIM_DETAILS, CLAIMS_HISTORY, CLAIMS, SUBMIT_CLAIM } from '../../routes/routes';
import { GoogleApiWrapper } from 'google-maps-react';
import { validateCellphoneNumber, validateSurname } from '../../constants/validation';
import { showDrivableNoModal, showSendContinueOnPhone, showSelectedDamageCar, showSelectedDamageMB, showDuplicateClaim } from '../../actions/modalActions';
import { setDate, setTime, setInfoFromFNOL } from '../../actions/claimSubmitActions';
import '../TimePicker/TimePicker.css';
import './FNOL.css';
import FnolStep1 from './FnolSteps/FnolStep1Overview'
import FnolStep2 from './FnolSteps/FnolStep2Where'
import FnolStep3 from './FnolSteps/FnolStep3What'
import FnolStep4 from './FnolSteps/FnolStep4Driveable'
import FnolStep5 from './FnolSteps/FnolStep5DamageReport'
import FnolStep6 from './FnolSteps/FnolStep6TakePhoto'
import FnolStep7 from './FnolSteps/FnolStep7'
import FnolStep8 from './FnolSteps/FnolStep8'
import FnolStep9 from './FnolSteps/FnolStep9'
import FnolStep10 from './FnolSteps/FnolStep10'
import FnolStep11 from './FnolSteps/FnolStep11'
import ClaimFAQ from './FAQ/ClaimFAQ'
import WarrantyClaimsJourney from './Warranty/WarrantyClaimsJourney'

import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
}
    from 'react-places-autocomplete';
import { CLAIM_TYPE_CELLPHONE, CLAIM_TYPE_GLASS, CLAIM_TYPE_NORMAL, CLAIM_TYPE_VAP, CLAIM_TYPE_WARRANTY } from '../../constants/constants';

var lat = 0
var lng = 0

class ClaimCapture extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.state = {
            eventTypeList: null,
            selectedCover: null,
            selectedEvent: null,
            incidentTypeList: null,
            selectedIncidentType: null,
            selectedIncidentTypeValidationVisible: false,
            coverToggle: false,
            IncidentToggle: false,
            IncidentTypeToggle: false,
            indidentDate: '12:00pm',
            IsIncidentDateClicked: false,
            incidentDescription: "",
            incidentDescriptionValidationVisible: false,
            nextDisabled: true,
            submitDisabled: false,
            showMarker: false,
            claimNumber: "",
            carDriveableSet: false,
            isDriveable: false,
            carRecoveredSet: false,
            isRecovered: false,
            carRecoveredValidationVisible: false,
            carDriveableValidationVisible: false,
            name: this.props.profile.name + " " + this.props.profile.surname,
            nameValidationVisible: false,
            contact: this.props.profile.cellphoneNumber,
            lat: 0,
            lng: 0,
            contactValidationVisible: false,
            step1Complete: false,
            step2Complete: false,
            step3Complete: false,
            adressSelect: "",
            continueDesktop: false,
            isCar: false,
            DescriptionWhereDisabled: false,
            DescriptionWhereSubmitted: false,
            DescriptionWhatDisabled: false,
            DescriptionWhatSubmitted: false,
            hasCause: false,
            hasDate: false,
            hasTime: false,
            Step1Disabled: false,
            Step1Submitted: false,
            incidentDescriptionWhat: "",
            startDate: "",
            maxDate: new Date(),
            time12: props.time,
            time24: null,
            causeOfCollision: "",
            selectAll: false,
            damageFront: false,
            damageFrontLeft: false,
            damageFrontRight: false,
            damageBackLeft: false,
            damageBackRight: false,
            damageBack: false,
            damageIsInEdit: false,
            continueDamage: true,
            modalDamagePhotoTypes: [],
            carDamageExtras: ["Undercarriage damage", "Interior", "Airbag popped", "Sunroof", "Roof", "Locks"],
            mbDamageExtras: ["Seat", "Sprocket", "Gas tank", "Frame", "Passenger seat", "Chain", "Engine", "Drive train", "Instruments", "Suspension"],
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handleContinueDesktop = this.handleContinueDesktop.bind(this);
        this.handleIsDrivable = this.handleIsDrivable.bind(this);
        this.handleNextMobile = this.handleNextMobile.bind(this);
        this.handleCoverSelection = this.handleCoverSelection.bind(this);
        this.handleCoverSelectionMobile = this.handleCoverSelectionMobile.bind(this);
        this.handleIncidentSelectionMobile = this.handleIncidentSelectionMobile.bind(this);
        this.handleIncidentTypeDropdownToggle = this.handleIncidentTypeDropdownToggle.bind(this);
        this.handleCoverDropdownToggle = this.handleCoverDropdownToggle.bind(this);
        this.handleIncidentSelection = this.handleIncidentSelection.bind(this);
        this.handleIncidentToggle = this.handleIncidentToggle.bind(this);
        this.handleIndidentDateClicked = this.handleIndidentDateClicked.bind(this);
        this.handleBackStep2 = this.handleBackStep2.bind(this);
        this.handleBackStep1 = this.handleBackStep1.bind(this);
        this.handleIncidentEventTypeSelection = this.handleIncidentEventTypeSelection.bind(this);
        this.handeCanDrive = this.handeCanDrive.bind(this);
        this.handeCanRecover = this.handeCanRecover.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeStep1 = this.handleChangeStep1.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.Submit = this.Submit.bind(this);
        this.handleStep1Submit = this.handleStep1Submit.bind(this);
        this.mapReady = this.mapReady.bind(this);
        this.handleAdressSelect = this.handleAdressSelect.bind(this);
        this.handleAdressChange = this.handleAdressChange.bind(this);
        this.updateLatLngAdress = this.updateLatLngAdress.bind(this);
        this.handleChangeDescriptionWhere = this.handleChangeDescriptionWhere.bind(this);
        this.handleChangeDescriptionWhat = this.handleChangeDescriptionWhat.bind(this);
        this.handleChangeDateValue = this.handleChangeDateValue.bind(this);
        this.setTime = this.setTime.bind(this);
        this.selectCauseOfCollision = this.selectCauseOfCollision.bind(this);
        this.handleContinueMobile = this.handleContinueMobile.bind(this);
        this.handleSubmitHow = this.handleSubmitHow.bind(this);
        this.handleIsDrivableYes = this.handleIsDrivableYes.bind(this);
        this.handleSelectAll = this.handleSelectAll.bind(this);
        this.handleSelectDamagePos = this.handleSelectDamagePos.bind(this);
        this.handleEditSelectedDamage = this.handleEditSelectedDamage.bind(this);
        this.checkDamageNext = this.checkDamageNext.bind(this);
        this.handleSubmitDamageReportStep1 = this.handleSubmitDamageReportStep1.bind(this);
        this.checkDamageExtras = this.checkDamageExtras.bind(this);
        this.handleIncidentEventSelection = this.handleIncidentEventSelection.bind(this);
        this.checkSubmitDescriptionWhere = this.checkSubmitDescriptionWhere.bind(this);
        this.checkWhatSubmit = this.checkWhatSubmit.bind(this);
    }

    checkDamageNext() {
        if (this.props.claimSubmit.selectedDamagePhotoTypes.length == 0 && !this.state.selectAll) {
            this.setState({ continueDamage: true })
        }
        else if (this.state.selectAll) {
            this.setState({ continueDamage: false })
        }
        else if (this.props.claimSubmit.selectedDamagePhotoTypes.length > 0) {
            this.setState({ continueDamage: false })
        }
    }

    checkDamageExtras(desc, isCar) {
        if (isCar) {
            return this.state.carDamageExtras.indexOf(desc) >= 0 ? true : false;
        }
        else {
            return this.state.mbDamageExtras.indexOf(desc) >= 0 ? true : false;
        }
    }


    async setClaimDamagePhotoTypes(data: any) {
        var curVal = document.getElementById(data.description)?.getAttribute('src');
        if (curVal == "/my-policy/Images/Claims/grey-checkmark-unchecked.png") {
            document.getElementById(data.description)?.setAttribute('src', "/my-policy/Images/Claims/grey-checkmark-checked.png");
        }
        else {
            document.getElementById(data.description)?.setAttribute('src', "/my-policy/Images/Claims/grey-checkmark-unchecked.png");
        }
    }

    handleSubmitHow() {
        this.setState({ DescriptionWhatSubmitted: true });
        if (this.state.incidentDescriptionWhat) {
            this.props.dispatchSetStep(7);
        } else {
            this.setState({ DescriptionWhatDisabled: true });
        }
    }

    handleIsDrivableYes() {
        this.props.dispatchSetStep(8);
    }

    handleSubmitDamageReportStep1() {
        this.props.dispatchSetStep(9);
    }

    async handleEditSelectedDamage() {
        await this.setState({ damageIsInEdit: !this.state.damageIsInEdit });
        this.props.dispatchIsInEdit(this.state.damageIsInEdit);
        await this.checkDamageNext();
    }

    async handleSelectAll() {

        if (this.state.selectAll) {
            await this.setState({
                selectAll: false
            })
            this.props.dispatchSetSelectedAllFalse();
        }
        else {
            await this.setState({ selectAll: true })
            this.props.dispatchSetSelectedAllTrue();
        }

        await this.checkDamageNext();

    }

    async handleSelectDamagePos(pos: string) {
        await this.setState({ damageIsInEdit: false });
        await this.props.dispatchIsInEdit(this.state.damageIsInEdit);

        switch (pos) {
            case 'front':
                this.props.claimSubmit.isCar ? await this.props.dispatchShowSelectedDamageCar('Front') : await this.props.dispatchShowSelectedDamageMB('Front');
                await this.checkDamageNext();
                break;
            case 'frontLeft':
                this.props.claimSubmit.isCar ? await this.props.dispatchShowSelectedDamageCar('Front left') : await this.props.dispatchShowSelectedDamageMB('Front left');
                await this.checkDamageNext();
                break;
            case 'frontRight':
                this.props.claimSubmit.isCar ? await this.props.dispatchShowSelectedDamageCar('Front right') : await this.props.dispatchShowSelectedDamageMB('Front right');
                await this.checkDamageNext();
                break;
            case 'backLeft':
                this.props.claimSubmit.isCar ? await this.props.dispatchShowSelectedDamageCar('Back left') : await this.props.dispatchShowSelectedDamageMB('Back left');
                await this.checkDamageNext();
                break;
            case 'backRight':
                this.props.claimSubmit.isCar ? await this.props.dispatchShowSelectedDamageCar('Back right') : await this.props.dispatchShowSelectedDamageMB('Back right');
                await this.checkDamageNext();
                break;
            case 'back':
                this.props.claimSubmit.isCar ? await this.props.dispatchShowSelectedDamageCar('Back') : await this.props.dispatchShowSelectedDamageMB('Back');
                await this.checkDamageNext();
                break;
        }
    }

    handleChangeDescriptionWhere(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        this.setState({ [name]: value });

        this.checkSubmitDescriptionWhere();
    }

    checkSubmitDescriptionWhere() {
        if (this.state.incidentDescriptionWhere) {
            this.setState({ DescriptionWhereDisabled: false });
        } else {
            this.setState({ DescriptionWhereDisabled: true });
        }
    }

    async handleRemoveFromList(item) {
        if (this.state.damageIsInEdit) {
            var newArr = this.props.claimSubmit.selectedDamagePhotoTypes.filter(x => x !== item);
            await this.props.dispatchSetSelectedDamagePhotoTypes(newArr);
            this.props.dispatchAddDamagePosition(this.props.claimSubmit.selectedDamagePhotoTypes);
        }
    }

    selectCauseOfCollision(event: any) {
        this.setState({
            causeOfCollision: event,
            hasCause: true
        });

        if (this.state.Step1Submitted) {
            this.checkStep1Answers();
        }
    }

    checkStep1Answers() {
        if (this.state.hasCause && this.state.hasDate && this.state.hasTime && this.state.name && this.state.contact) {
            this.setState({ Step1Disabled: false })
        }
        else {
            this.setState({ Step1Disabled: true })
        }
    }

    handleChangeDateValue(date) {
        this.setState({
            startDate: date
        });
        this.props.dispatchSetDate(date);
        this.setState({ hasDate: true });
        if (this.state.Step1Submitted) {
            this.checkStep1Answers();
        }
    }
    async setTime(f12: any, f24: any) {
        await this.setState({ time12: f12, time24: f24 });
        await this.props.dispatchSetTime(f12, f24)
        this.props.dispatchSetTimeShow();
        this.setState({ hasTime: true });
        if (this.state.Step1Submitted) {
            this.checkStep1Answers();
        }
    }

    handleChangeDescriptionWhat(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        this.setState({ [name]: value });

        if (this.state.DescriptionWhatSubmitted) {
            this.checkWhatSubmit();
        }
    }

    checkWhatSubmit() {
        if (this.state.incidentDescriptionWhat) {
            this.setState({ DescriptionWhatDisabled: false });
        } else {
            this.setState({ DescriptionWhatDisabled: true });
        }
    }

    async updateLatLngAdress(Lat, Lng, address) {
        lat = Lat
        lng = Lng
        await this.setState({ lat: Lat, lng: Lng, adressSelect: address })
        this.checkSubmitDescriptionWhere();

    };

    handleAdressChange = address => {
        this.setState({ adressSelect: address });
        this.checkSubmitDescriptionWhere();
    };

    handleAdressSelect = address => {
        geocodeByAddress(address)
            .then(results => getLatLng(results[0]))
            .then(latLng => this.updateLatLngAdress(latLng.lat, latLng.lng, address))
            .catch();
    };

    handleRedirect() {
        this.props.redirectTo(CLAIMS_HISTORY);
    }

    handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        this.setState({ [name]: value });
    }

    handleChangeStep1(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        this.setState({ [name]: value });

        if (this.state.Step1Submitted) {
            this.checkStep1Answers();
        }
    }

    async handleSubmit(e: any) {
        let locationSet = await this.props.dispatchLocation(lat, lng);
        if (locationSet) {
            if (this.state.selectedCover !== undefined && (this.props.claimSubmit.selectedCover.product === 1 || this.props.claimSubmit.selectedCover.product === 7)) {

                await this.setState({
                    incidentDescriptionValidationVisible: this.state.incidentDescription === "",
                    nameValidationVisible: (await validateSurname.test(this.state.name) !== true),
                    contactValidationVisible: (await validateCellphoneNumber.test(this.state.contact) !== true),
                    carRecoveredValidationVisible: (!this.state.carRecoveredSet),
                    carDriveableValidationVisible: (!this.state.carDriveableSet),
                });

                if (this.props.claimSubmit.incidentEventType.id === 999) {
                    await this.setState({
                        selectedIncidentTypeValidationVisible: true,
                    });
                }

                if (!(this.state.selectedIncidentTypeValidationVisible || this.state.incidentDescriptionValidationVisible ||
                    this.state.nameValidationVisible || this.state.contactValidationVisible ||
                    this.state.carRecoveredValidationVisible || this.state.carDriveableValidationVisible)) {
                    await this.Submit();
                }
            }
            else {
                await this.setState({
                    incidentDescriptionValidationVisible: this.state.incidentDescription === "",
                    nameValidationVisible: (await validateSurname.test(this.state.name) !== true),
                    contactValidationVisible: (await validateCellphoneNumber.test(this.state.contact) !== true),
                });

                if (this.props.claimSubmit.incidentEventType.id === 999) {
                    await this.setState({
                        selectedIncidentTypeValidationVisible: true,
                    });
                }

                if (!(this.state.selectedIncidentTypeValidationVisible || this.state.incidentDescriptionValidationVisible ||
                    this.state.nameValidationVisible || this.state.contactValidationVisible)) {
                    await this.Submit();
                }
            }
        }
    }

    async Submit() {
        this.setState({ DescriptionWhereSubmitted: true })
        if (this.state.incidentDescriptionWhere) {
            this.props.dispatchSetStep(6);
        }
        else {
            this.setState({ DescriptionWhereDisabled: true })
        }
    }

    async handleStep1Submit() {
        this.setState({ Step1Submitted: true })
        if (this.state.hasCause && this.state.hasDate && this.state.hasTime && this.state.name && this.state.contact) {
            this.props.dispatchSetStep(5);
        } else {
            this.setState({ Step1Disabled: true })
        }
    }


    handeCanDrive(e: any) {
        if (e === "true") {
            this.setState({
                carDriveableSet: true,
                carRecoveredSet: true,
                isDriveable: true
            });
        }
        else {
            this.setState({
                carDriveableSet: true,
                carRecoveredSet: true,
                isDriveable: false
            });
        }

    }

    handeCanRecover(e: any) {
        if (e === "true") {
            this.setState({
                carRecoveredSet: true,
                isRecovered: true,
                carDriveableSet: true,
            });
        }
        else {
            this.setState({
                carRecoveredSet: true,
                isRecovered: false,
                carDriveableSet: true,
            });
        }
    }

    handleIndidentDateClicked() {
        this.props.dispatchSetTimeShow()
    }



    handleResetStep() {
        this.props.dispatchSetStep(1, 1);
    }

    async mapReady(mapProps, map) {
        lat = map.center.lat()
        lng = map.center.lng()
        await this.setState({ lat: lat, lng: lng })
        map.addListener("click", (mapsMouseEvent) => {
            lat = mapsMouseEvent.latLng.toJSON().lat
            lng = mapsMouseEvent.latLng.toJSON().lng
            this.setState({ lat: lat, lng: lng })
        });
    }

    async handleClick(e: any) {
        await this.getAllIncidentTypes(e.target.id);
    }

    async handleNext(e: any) {
        await this.props.dispatchSetRiskItemAndIncident(this.state.selectedCover, this.state.selectedEvent)
        await this.setState({
            step1Complete: true,
        });
        if ((this.props.claimSubmit.incidentType.id === 1) && (this.props.claimSubmit.selectedRiskItem.product === 1 || this.props.claimSubmit.selectedRiskItem.product === 2 || this.props.claimSubmit.selectedRiskItem.product === 7)) {//car, chilli and motorbike for new FNOL
            await this.props.dispatchSetStep(2);
        }
        else {
            await this.props.dispatchSetStep(2);
            this.props.dispatchSetClaimData(this.props.claimSubmit.selectedClaimStep.step, this.props.claimSubmit.selectedRiskItem, this.props.claimSubmit.incidentType);
            this.props.redirectTo(SUBMIT_CLAIM);
        }
    }

    async handleContinueMobile() {
        this.props.dispatchShowSendContinueOnPhone(this.props.profile.cellphoneNumber);
    }

    async handleContinueDesktop(e: any) {
        await this.setState({
            continueDesktop: true,
            claimProgress: true
        })

        await this.props.dispatchSetStep(3);

    }

    async handleIsDrivable(e: any) {

        if (this.state.selectedCover.product === 1 || this.state.selectedCover.product === 2 || this.state.selectedCover.product === 6) {
            await this.setState({
                isCar: true,
            })
            await this.props.dispatchSetIsCar(true);
        }
        else if (this.state.selectedCover.product === 7) {
            await this.setState({
                isCar: false,
            })
            await this.props.dispatchSetIsCar(false);
        }
        this.props.claimSubmit.isCar ? await this.props.dispatchGetClaimDamagePhotoTypes(6) : await this.props.dispatchGetClaimDamagePhotoTypes(7);
        await this.props.dispatchSetStep(4);

    }

    async handleNextMobile(e: any) {
        let claimExists = false;
        if (this.props.profile.personalClaims !== undefined) {
            for (var i = 0; i < this.props.profile.personalClaims.length; i++) {
                var claim = this.props.profile.personalClaims[i];
                if (claim.riskItemDetails.id === this.state.selectedCover.id && claim.productIncidentType.incidentType.incidentEventType.id === this.state.selectedEvent.id && claim.claimStatus !== "Approved") {
                    claimExists = true;
                    break;
                }
            };
        }
        await this.props.dispatchSetRiskItemAndIncident(this.state.selectedCover, this.state.selectedEvent)
        if (claimExists) {
            this.props.dispatchShowDuplicateClaim();
        }
        else {
            await this.setState({
                step1Complete: true,
            });
            this.props.redirectTo(SUBMIT_CLAIM_DETAILS);
        }
    }


    async getIncidentTypes(riskItemId) {
        await postToController(this.props.dispatch, 'GetEventTypes', JSON.stringify({ Parameter: riskItemId })).then(async (response) => {
            await this.setState({ eventTypeList: response });
            return true;
        })
    }

    async getAllIncidentTypes(riskItemId) {
        await postToController(this.props.dispatch, 'GetAllEventTypes', JSON.stringify({ Parameter: riskItemId })).then(async (response) => {
            await this.setState({ eventTypeList: response });
            return true;
        })
    }

    async getClaimDamagePhotoTypes(riskItemTypeId: number) {

    }

    async getIncidentTypesByIncidentEventTypeId(incidentEventType) {
        await postToController(this.props.dispatch, 'GetIncidentTypesByIncidentEventTypeId', JSON.stringify({ EventTypeId: incidentEventType.id })).then(async (response) => {
            await this.setState({ incidentTypeList: response });
            await this.props.dispatchSetIncidentEventList(response, incidentEventType);
            return true;
        })
    }

    async getIncidentTypesByIncidentEventTypeIdMobile(incidentEventType) {
        await postToController(this.props.dispatch, 'GetIncidentTypesByIncidentEventTypeId', JSON.stringify({ EventTypeId: incidentEventType.id })).then(async (response) => {
            await this.setState({ incidentTypeList: response });
            await this.props.dispatchSetIncidentEventList(response, incidentEventType);
            return true;
        })
    }

    async handleCoverSelection(e: any) {
        let coverItem = this.props.profile.personalPolicies[0].covers.filter(function (item) {
            return item.id == e
        })
        await this.getAllIncidentTypes(coverItem[0].id)
        await this.setState({ selectedCover: coverItem[0], selectedEvent: null });
    }

    async handleIncidentEventSelection(e: any) {
        let coverItem = this.props.claimSubmit.incidentEventList.filter(function (item) {
            return item.id == e
        })
        await this.setState({ causeOfCollision: coverItem[0], hasCause: true });
    }

    async handleCoverSelectionMobile(e: any) {
        let coverItem = this.props.profile.personalPolicies[0].covers.filter(function (item) {
            return item.id == e
        })
        await this.getAllIncidentTypes(coverItem[0].id)
        await this.setState({ selectedCover: coverItem[0] });
        await this.props.dispatchSetCover(coverItem[0]);
    }

    async handleCoverDropdownToggle(e: any) {
        await this.setState({
            coverToggle: !this.state.coverToggle
        });
    }

    async handleBackStep2(e: any) {
        await this.setState({
            step1Complete: false,
            step2Complete: false,
        });
        await this.props.dispatchSetStep(1);
    }

    async handleBackStep1(e: any) {
        this.props.redirectTo(CLAIMS);
    }

    async handleIncidentTypeDropdownToggle(e: any) {
        await this.setState({
            IncidentTypeToggle: !this.state.IncidentTypeToggle
        });
    }

    async handleIncidentSelection(e: any) {
        let eventType = this.state.eventTypeList.filter(function (item) {
            return item.id == e
        })
        await this.setState({ selectedEvent: eventType[0] });
        this.props.dispatchSetIncidentEvent(eventType[0])
        await this.setState({ nextDisabled: false });

        this.getIncidentTypesByIncidentEventTypeId(eventType[0])
    }

    async handleIncidentSelectionMobile(e: any) {
        if (this.state.eventTypeList) {
            let eventType = this.state.eventTypeList.filter(function (item) {
                return item.id == e
            })
            await this.setState({ selectedEvent: eventType[0] });
            this.props.dispatchSetIncidentEvent(eventType[0])
            await this.setState({ nextDisabled: false });
            this.getIncidentTypesByIncidentEventTypeId(eventType[0])
        }
    }

    async handleIncidentEventTypeSelection(e: any) {
        let incidentType = this.state.incidentTypeList.filter(function (item) {
            return item.id == e
        })
        await this.setState({ selectedIncidentType: incidentType[0] });
    }

    async handleIncidentEventTypeSelectionMobile(e: any) {
        let incidentType = this.state.incidentTypeList.filter(function (item) {
            return item.id == e
        })
        await this.setState({ selectedIncidentType: incidentType[0] });
    }

    async handleIncidentToggle(e: any) {
        await this.setState({
            IncidentToggle: !this.state.IncidentToggle
        });
    }

    public render() {
        return (
            <>
                {(this.props.claimSubmit.claimType === CLAIM_TYPE_WARRANTY || this.props.claimSubmit.claimType === CLAIM_TYPE_VAP) && <WarrantyClaimsJourney />}
                {(this.props.claimSubmit.claimType !== CLAIM_TYPE_WARRANTY && this.props.claimSubmit.claimType !== CLAIM_TYPE_VAP) &&
                    <>
                        {this.props.claimSubmit.selectedClaimStep.step === 11 && this.props.claimSubmit.claimType === CLAIM_TYPE_NORMAL && <FnolStep11 />}
                        {/* /// Desktop Content Area /// */}
                        <div className={"d-none d-sm-none d-md-none d-lg-block d-xl-block col-12" + (this.props.ssp.drivableClaimsEnabled && this.props.claimSubmit.selectedClaimStep.step === 10 ? " content-box-padding-20px" : " content-box-padding-20px-bottom-40px") + " fnol-steps-content-area-desktop" + (this.props.claimSubmit.selectedClaimStep.subStep === 3 ? 'content-box-padding-20px-top-30px-bottom-40px' : '')}>
                            {this.props.claimSubmit.selectedClaimStep.step === 1 && <FnolStep1 />}
                            <div className="fnol-steps-extra-div-hunt">
                                {this.props.claimSubmit.selectedClaimStep.step === 2 && <FnolStep2 />}
                            </div>
                            {this.props.claimSubmit.selectedClaimStep.step === 3 && <FnolStep3 />}
                            {this.props.claimSubmit.selectedClaimStep.step === 4 && <FnolStep4 />}
                            {this.props.claimSubmit.selectedClaimStep.step === 5 && <FnolStep5 />}
                            {this.props.claimSubmit.selectedClaimStep.step === 6 && <FnolStep6 />}
                            {this.props.claimSubmit.selectedClaimStep.step === 7 && <FnolStep7 />}
                            {this.props.claimSubmit.selectedClaimStep.step === 8 && <FnolStep8 />}
                            {this.props.claimSubmit.selectedClaimStep.step === 9 && <FnolStep9 />}
                            {this.props.claimSubmit.selectedClaimStep.step === 10 && <FnolStep10 />}
                            {this.props.claimSubmit.selectedClaimStep.step === 11 && this.props.claimSubmit.claimType === CLAIM_TYPE_GLASS && <FnolStep11 />}
                            {this.props.claimSubmit.selectedClaimStep.step === 11 && this.props.claimSubmit.claimType === CLAIM_TYPE_CELLPHONE && <FnolStep11 />}
                        </div>
                        {/* /// Mobile Content Area /// */}
                        <div className="d-block d-sm-block d-md-block d-lg-none d-xl-none col-12 content-box-padding-20px-bottom-40px fnol-steps-content-area-mobile">
                            <div className="row noma">
                                <div className={"col-2 col-md-1 fnol-steps-progress-header-icon " + (this.props.claimSubmit.selectedClaimStep.subStep === 3 ? 'fnol-step1-substep3-hide-progress-header' : '')}>
                                    {/*/// NOTE: Re Commented Headers: ///
                            {/* These will be eventually removed, but are maintained until they've all been moved to their actual pages /*}
                            {/* and tested properly ///*/}
                                    {this.props.claimSubmit.selectedClaimStep.step === 6 && this.props.claimSubmit.claimType === CLAIM_TYPE_NORMAL && <img className="pt-3" src='/my-policy/Images/FNOL/Progress/6.png' />}
                                </div>
                                <div className={"col-10 col-md-11 fnol-steps-progress-header-text " + (this.props.claimSubmit.selectedClaimStep.subStep === 3 ? 'fnol-step1-substep3-hide-progress-header' : '')}>
                                    {this.props.claimSubmit.selectedClaimStep.step == 6 && this.props.claimSubmit.claimType === CLAIM_TYPE_NORMAL &&
                                        <h3 className="claim-title pt-3 mb-1 mt-1">Take photos</h3>
                                    }
                                </div>
                                {this.props.claimSubmit.selectedClaimStep.step === 1 && <FnolStep1 />}
                                <div className="fnol-steps-extra-div-hunt">
                                    {this.props.claimSubmit.selectedClaimStep.step === 2 && <FnolStep2 />}
                                </div>
                                {this.props.claimSubmit.selectedClaimStep.step === 3 && <FnolStep3 />}
                                {this.props.claimSubmit.selectedClaimStep.step === 4 && <FnolStep4 />}
                                {this.props.claimSubmit.selectedClaimStep.step === 5 && <FnolStep5 />}
                                {this.props.claimSubmit.selectedClaimStep.step === 6 && this.props.claimSubmit.claimType === CLAIM_TYPE_NORMAL && <>
                                    <hr className="Line w-100" />
                                    <p className="mt-2">Please take good quality photos by
                                        <br />
                                        Checking that they're not blurred
                                        <br />
                                        Using good lighting
                                    </p>
                                    <FnolStep6 /></>}
                                {this.props.claimSubmit.selectedClaimStep.step === 6 && this.props.claimSubmit.claimType === CLAIM_TYPE_GLASS && <> <FnolStep6 /></>}
                                {this.props.claimSubmit.selectedClaimStep.step === 6 && this.props.claimSubmit.claimType === CLAIM_TYPE_CELLPHONE && <> <FnolStep6 /></>}
                                {this.props.claimSubmit.selectedClaimStep.step === 7 && <FnolStep7 />}
                                {this.props.claimSubmit.selectedClaimStep.step === 8 && <FnolStep8 />}
                                {this.props.claimSubmit.selectedClaimStep.step === 9 && <FnolStep9 />}
                                {this.props.claimSubmit.selectedClaimStep.step === 10 && <FnolStep10 />}
                                {this.props.claimSubmit.selectedClaimStep.step === 11 && this.props.claimSubmit.claimType === CLAIM_TYPE_GLASS && <FnolStep11 />}
                                {this.props.claimSubmit.selectedClaimStep.step === 11 && this.props.claimSubmit.claimType === CLAIM_TYPE_CELLPHONE && <FnolStep11 />}
                            </div>
                        </div>
                        {/* /// Claims FAQ Content Area /// */}
                        <ClaimFAQ />
                    </>
                }
            </>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        claimSubmit: state.claimSubmit,
        ssp: state.ssp
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchSubmitClaim: (data) => dispatch(submitClaim(data)),
        dispatchLocation: (lat, lng) => dispatch(setLocation(lat, lng)),
        dispatchSetTimeShow: () => dispatch(setTimeShow()),
        dispatchSetCover: (data) => dispatch(setCover(data)),
        dispatchSetIncidentEventList: (list, event) => dispatch(setFnolIncidentEventList(list, event)),
        dispatchSetIncidentEvent: (event) => dispatch(setIncidentEvent(event)),
        handleNotDrivableModal: () => dispatch(showDrivableNoModal()),
        dispatchSetStep: (step, subStep) => dispatch(setStep(step, subStep)),
        dispatchSetDate: (data) => dispatch(setDate(data)),
        dispatchSetTime: (time12, time24) => dispatch(setTime(time12, time24)),
        dispatchSetIsCar: (isCar) => dispatch(setIsCar(isCar)),
        dispatchGetClaimDamagePhotoTypes: (riskItemType) => dispatch(getClaimDamagePhotoTypes(riskItemType)),
        dispatchShowSelectedDamageCar: (position) => dispatch(showSelectedDamageCar(position)),
        dispatchSetSelectedDamagePhotoTypes: (riskItemType) => dispatch(setSelectedDamagePhotoTypes(riskItemType)),
        dispatchAddDamagePosition: (pos) => dispatch(setDamagePosition(pos)),
        dispatchSetSelectedAllTrue: () => dispatch(setSelectedAllTrue()),
        dispatchSetSelectedAllFalse: () => dispatch(setSelectedAllFalse()),
        dispatchSetRiskItemAndIncident: (riskItem, incidentType) => dispatch(setRiskItemAndIncident(riskItem, incidentType)),
        dispatchShowSendContinueOnPhone: (phoneNumber) => dispatch(showSendContinueOnPhone(phoneNumber)),
        dispatchShowSelectedDamageMB: (position) => dispatch(showSelectedDamageMB(position)),
        dispatchShowDuplicateClaim: () => dispatch(showDuplicateClaim()),
        dispatchHandleStepBack: () => dispatch(handleStepBack()),
        dispatchHandleNextStep: () => dispatch(handleNextStep()),
        dispatchIsInEdit: (isEdit) => dispatch(setIsInEdit(isEdit)),
        dispatchSetClaimData: (step, riskItem, event) => dispatch(setInfoFromFNOL(step, riskItem, event)),
    }
}

const connector = connect(mapStateToProps, mapDispatchToProps)(ClaimCapture);

export default GoogleApiWrapper({
    apiKey: 'AIzaSyA-H0lUISGUeL7ipjcqTTwK3gmMaSZynR8'
})(connector);